export default __webpack_public_path__ + "static/footer-3-1ee8f46946b76049f57b3453e8c5d6c7.jpg";